import {Injectable} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {PromptDialogComponent} from '../../../shared/lina-generic-dialogs/lina-generic-dialogs.component';
import {first} from 'rxjs/operators';
import {Clipboard} from '@angular/cdk/clipboard';

@Injectable()
export class SnackBarMessageService {
  defaultConfig: MatSnackBarConfig = {
    duration: 4000,
    horizontalPosition: 'end',
    verticalPosition: 'top'
  };

  constructor(private snackBar: MatSnackBar,
              private translate: TranslateService,
              private dialog: MatDialog,
              private clipboard: Clipboard) { }

  postResponseError(content?) {
    const traceIdentifier = content ? content.TraceIdentifier : null;
    const details = content && content.Details ? content.Details : null;
    const message = content && content.Message && content.ErrorCode && content.Message !== content.ErrorCode ? content.Message : null;
    if (content && content.ErrorCode) {
      content = 'LINA_BACKEND_ERROR_' + content.ErrorCode;
    } else {
      content = 'TOAST_REQUEST_ERROR';
    }

    this.translate.get(content).subscribe((res: string) => {
      if (content === res) {
        content = this.translate.instant('TOAST_REQUEST_ERROR');
      } else {
        content = res;
        if(details)
        {
          content += ': ' + details;
        }
        if(message)
        {
          content += ': ' + message;
        }
      }
    });

    if (content && traceIdentifier) {
      return this.traceIdentifierSnackbar(
        content,
        traceIdentifier,
        null,
        null,
        null);
    } else {
      return this.customStyleSnackBar('snack-bar-error',
        content,
        null,
        null,
        null);
    }
  }

  postResponseSuccess() {
    return this.customStyleSnackBar('snack-bar-success',
      'TOAST_REQUEST_SUCCESS',
      null,
      null,
      null);
  }

  getResponseError() {
    return this.customStyleSnackBar('snack-bar-error',
      'TOAST_REQUEST_ERROR',
      null,
      null,
      null);
  }

  infoSnackBar(content, duration?, horizontalPosition?, verticalPosition?) {
    return this.customStyleSnackBar('snack-bar-info',
      content,
      duration,
      horizontalPosition,
      verticalPosition);
  }

  successSnackBar(content, duration?, horizontalPosition?, verticalPosition?) {
    return this.customStyleSnackBar('snack-bar-success',
      content,
      duration,
      horizontalPosition,
      verticalPosition);
  }

  errorSnackBar(content, duration?, horizontalPosition?, verticalPosition?) {
    return this.customStyleSnackBar('snack-bar-error',
      content,
      duration,
      horizontalPosition,
      verticalPosition);
  }

  customStyleSnackBar(customClass, content, duration?, horizontalPosition?, verticalPosition?) {
    return this.snackBar.open(this.translate.instant(content), 'X', {
      duration: duration || this.defaultConfig.duration,
      horizontalPosition: horizontalPosition || this.defaultConfig.horizontalPosition,
      verticalPosition: verticalPosition || this.defaultConfig.verticalPosition,
      panelClass: [customClass]
    });
  }

  traceIdentifierSnackbar(content, traceIdentifier, duration?, horizontalPosition?, verticalPosition?) {
    const snackRef = this.snackBar.open(this.translate.instant('MULTIPLE_ERRORS_FOUND'), this.translate.instant('COPY') + ' ' + this.translate.instant('ERROR_CODE'), {
      duration: duration || 10000,
      horizontalPosition: horizontalPosition || this.defaultConfig.horizontalPosition,
      verticalPosition: verticalPosition || this.defaultConfig.verticalPosition,
      panelClass: 'snack-bar-error'
    });

    snackRef.onAction().pipe(first()).subscribe(() => {
      this.clipboard.copy('Unknown error occurred in Lina with trace identifier: ' + traceIdentifier);
      snackRef.dismiss();
    });
  }

  multipleResponseSnackBar(content, duration?, horizontalPosition?, verticalPosition?) {
    const success = content.SuccessResponse.length;
    const error = content.ErrorResponse.length;


    const snackRef = this.snackBar.open(this.translate.instant(error + '/' + (error + success) + ' ' +
      this.translate.instant('FAILED')), this.translate.instant('SHOW'), {
      duration: duration || 10000,
      horizontalPosition: horizontalPosition || this.defaultConfig.horizontalPosition,
      verticalPosition: verticalPosition || this.defaultConfig.verticalPosition,
      panelClass: 'snack-bar-error'
    });

    snackRef.onAction().pipe(first()).subscribe(() => {
      let errors = '';
      content.ErrorResponse.forEach(err => {
        let backendErrorCode = 'LINA_BACKEND_ERROR_' + err.ErrorCode;
        let translatedError = this.translate.instant(backendErrorCode) === backendErrorCode ? this.translate.instant(err.ErrorCode) : this.translate.instant(backendErrorCode);
        errors += '<b>' + err.EntityIdentifier + '</b>: ' + translatedError + '<br>';
      });

      const dialogRef = this.dialog.open(PromptDialogComponent, {
        panelClass: ['dialog-medium-size', 'mat-typography'],
        data: {title: '' , body:
            '<p>' + this.translate.instant('MULTIPLE_ERROR_DESCRIPTION') + '</p>' +
            errors,
        }});
    });
  }

  detailedErrorSnackBar(content, duration?, horizontalPosition?, verticalPosition?) {

    const snackRef = this.snackBar.open(this.translate.instant('MULTIPLE_ERRORS_FOUND'), this.translate.instant('SHOW'), {
      duration: duration || 10000,
      horizontalPosition: horizontalPosition || this.defaultConfig.horizontalPosition,
      verticalPosition: verticalPosition || this.defaultConfig.verticalPosition,
      panelClass: 'snack-bar-error'
    });

    snackRef.onAction().pipe(first()).subscribe(() => {
      let errors = '';
      content.ErrorDetails.forEach(err => {
        errors += '<b>' + err.EntityAlias + '</b>: ' + this.translate.instant('LINA_BACKEND_ERROR_' + err.ErrorCode) + '<br>' + err.EntityId + '<br>' + err.Message +'<hr><br>';
      });

      const dialogRef = this.dialog.open(PromptDialogComponent, {
        panelClass: ['dialog-medium-size', 'mat-typography'],
        data: {title: 'MULTIPLE_ERRORS_FOUND' , body: errors}
      });
    });
  }
}
